import React, { memo, forwardRef } from 'react';
import { useTheme, createUseStyles, Icon, Text } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'ToFieldFormatter');

const ToFieldFormatter = ({ value }, ref) => {
    const classes = useStyles();
    const theme = useTheme();
    return (
        <div ref={ref} className={classes.toField}>
            <Text className={classes.toFieldName}>{value}</Text>
            <Icon name="arrowRight" color={theme.colors.grey[200]}></Icon>
        </div>
    );
};

export default memo(forwardRef(ToFieldFormatter));
